import { render, staticRenderFns } from "./childAgency.vue?vue&type=template&id=8cb5fa68"
import script from "./childAgency.vue?vue&type=script&lang=js"
export * from "./childAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports